import React from 'react'
import { RichText, type ComponentProps, type ExtendedRichTextData, type PartData } from '@enonic/react-components'
import EventAgendaPrototype from '/react4xp/components/prototype/EventAgenda'
import type { AgendaItem, SpeakerCard } from '/react4xp/components/prototype/EventAgenda/types'

type AgendaItemData = {
	time?: string
	title?: string
	text?: ExtendedRichTextData
}

type SpeakerData = {
	image?: { src?: string; srcThumbnail?: string; alt?: string }
	name?: string
	subtitle?: string
}

type EventAgendaPartData = {
	heading?: string
	agenda?: AgendaItemData[]
	speakersHeading?: string
	speakers?: SpeakerData[]
}

export const EventAgenda = ({ component, meta, data, common }: ComponentProps<PartData>) => {
	const { heading, agenda = [], speakersHeading, speakers = [] } = (data || {}) as EventAgendaPartData

	// The prototype's AgendaItem.richText is typed `string`, but this field's HtmlArea
	// includes Macro — only @enonic/react-components's RichText hydrates macro
	// placeholders, so a ReactNode is passed here instead of a raw HTML string.
	const agendaItems = agenda.map((item) => ({
		time: item.time,
		title: item.title,
		richText: item.text && <RichText tag="div" data={item.text} component={component} meta={meta} common={common} />,
	}))

	const speakerCards = speakers.map((speaker) => ({
		photo: speaker.image?.src ? { src: speaker.image.src, alt: speaker.image.alt || speaker.name || '' } : undefined,
		name: speaker.name,
		subtitle: speaker.subtitle,
	}))

	return (
		<EventAgendaPrototype
			agendaTitle={heading}
			agendaItems={agendaItems as unknown as AgendaItem[]}
			speakersTitle={speakersHeading}
			speakers={speakerCards as SpeakerCard[]}
		/>
	)
}
